import { defineMessages, useIntl } from 'react-intl';

import { Modal } from '@garnish/overlays';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsHeadline = () => {
  const { formatMessage } = useIntl();

  return <Modal.Headline sizeMatch={['32']}>{formatMessage(messages.headline)}</Modal.Headline>;
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  headline: {
    defaultMessage: 'Some ingredients are unavailable',
    description: 'Add To Bag | Unavailable ingredients | Headline',
  },
});
